import { ANALYTICS } from "../constants";
import { CellComponentProps } from "../types";
import RoleActions from "../../Role/RoleActions";

type RolesListItemActionsDropdownCellProps = CellComponentProps;

const RolesListItemActionsDropdownCell = ({ role }: RolesListItemActionsDropdownCellProps) => {
  return (
    <RoleActions
      role={role}
      analyticsPage={ANALYTICS.analyticsPage}
      refetchQueries={["GetRoles"]}
    />
  );
};

export default RolesListItemActionsDropdownCell;
